<template>
	<div class="login-wrap">
		<div class="ms-login">
			<!-- 标题 -->
			<div class="ms-title">{{login.login_0}}</div>
			<el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
				<el-form-item prop="username" class="ms-username">
					<el-input v-model="param.username" :placeholder="login.login_5" type="text" maxlength="11" oninput="value=value.replace(/[^\d]/g,'')"
					 clearable>
						<el-button slot="prepend" icon="el-icon-mobile-phone" style="cursor:default; height: 44px; color: #FFFFFF;background: #1890FF;"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item prop="password" class="ms-password">
					<el-input :type="passwordType" :placeholder="login.login_6" v-model="param.password" maxlength="18" clearable>
						<el-button slot="prepend" icon="el-icon-lx-lock" style="cursor:default; height: 44px;color: #FFFFFF;background: #1890FF;"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item prop="verifycode">
					<div class="verifys">
						<div class="verifys-txt">
							<el-input v-model="param.verifycode" :placeholder="login.login_7" class="identifyinput" 
							@keyup.enter.native="submitForm()" maxlength="4">
							</el-input>
						</div>
						<div class="verifys-image">
							<div class="verifys-image-code" @click="refreshCode">
								<!--验证码组件-->
								<s-identify :identifyCode="identifyCode"></s-identify>
							</div>
							<div class="verifys-image-button">
								<div class="verifys-image-assets" @click="refreshCode">
									<img width="20px" height="20px" src="../assets/img/change.png" />
								</div>
								<el-button @click="refreshCode" type='text' size="small" class="textbtn">{{login.login_2}}</el-button>
							</div>
						</div>
					</div>
				</el-form-item>
				<div class="login-txt">
					<div class="login-txt-forget">
						<!-- 忘记密码 -->
						<el-button @click="forgetPwd" type='text' class="textforget">{{login.login_3}}</el-button>
					</div>
					<div class="login-txt-chkbox">
						<!-- 记住账号 -->
						<el-checkbox v-model="checked" class="chkbox">{{login.login_4}}</el-checkbox>
					</div>
				</div>
				<div class="login-btn">
					<!-- 登录 -->
					<el-button type="primary" @click="submitForm()" :loading="authLoading" :disabled="isDisabled">{{login.login_1}}</el-button>
				</div>
			</el-form>
		</div>
		<div style="position: absolute; bottom: 20px; width: 100%; height: 30px; text-align: center;">
			<a style="color: white;" target="_blank" href="https://beian.miit.gov.cn/">辽ICP备20010444号</a>
		</div>
	</div>
</template>

<script>
	import SIdentify from '@/components/identify/identify.vue'; //导入图形验证码

	export default {
		data: function() {
			// 验证码自定义验证规则
			const validateVerifycode = (rule, value, callback) => {
				if (value == '') {
					callback(new Error(this.login.login_7)); //请输入验证码
				} else if (value !== this.identifyCode) {
					callback(new Error(this.login.login_8)); //验证码不正确
				} else {
					callback();
				}
			}

			const validateEmail = (rule, value, callback) => { //请输入手机号
				if (value === '') {
					callback(new Error(this.login.login_5));
				} else {
					/*if (value !== '') {
						var reg = /^([A-Za-z0-9_\.-]+)@([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})$/;
						if (!reg.test(value)) {
							callback(new Error(this.login.login_9)); //邮箱格式不正确
						}
					*/
					callback();
				}
			};
			
			const validatePwd = (rule, value, callback) => {	//请输入密码
							if (value === '') {
								callback(new Error(this.login.login_10)); 
							} else {
								callback();
							}
						};

			return {
				login: {
					login_0: "口袋家园服务端",
					login_1: "登录",
					login_2: "换一换",
					login_3: "忘记密码？",
					login_4: "记住账号",
					login_5: "请输入手机号",
					login_6: "请输入6-18位密码",
					login_7: "请输入验证码",
					login_8: "验证码不正确",
					login_9: "手机号格式不正确",
					login_10: "请输入密码",
					login_11: "密码长度在 6 到 18 位之间",
					login_12: "只能输入6-18个字母、数字、下划线",
					login_13: "登录成功",
					login_14: "该手机号未注册",
					login_15: "手机号密码错误",
					login_16: "网络请求失败",
					login_21: "老师不可以登录后台"
				},
				language: '',
				authLoading: false,
				isDisabled: false,

				param: {
					username: '',
					password: '',
					verifycode: ''
				},
				checked: false,
				identifyCodes: '1234567890',
				identifyCode: '',
				rules: {
					username: [{ //提示请输入手机号
						trigger: ['blur', 'change'],
						validator: validateEmail
					}],
					password: [{ //提示请输入密码
						trigger: ['blur', 'change'],
						validator: validatePwd
					}],


					// password: [{
					// 	required: true,
					// 	message: this.login.login_10, //请输入密码
					// 	trigger: 'blur'
					// }, {
					// 	min: 6,
					// 	max: 18,
					// 	message: this.login.login_11 //密码长度在 6 到 18 位之间
					// }, {
					// 	pattern: /^(\w){6,18}$/,
					// 	message: this.login.login_12 //只能输入6-18个字母、数字、下划线
					// }],

					verifycode: [{ //提示清输入验证码
						trigger: 'blur',
						validator: validateVerifycode
					}],
				},
				passwordType: 'password',
			};
		},
		components: {
			SIdentify
		},
		created() {
			let uname = this.param.username
			let upwd = this.param.password

			if (uname != null && upwd != null) {
				// 勾选
				this.checked = true
			} else {
				// 不勾选
				this.checked = false
			}
		},
		mounted() {
			// 初始化验证码
			this.refreshCode();
			// 在页面加载时获取登录信息
			this.getCookie();
		},
		methods: {
			//忘记密码
			forgetPwd() {
				//this.clearCookie();
				//this.$router.push('/forgetPwd');
			},
			// 生成随机数
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min)
			},
			// 切换验证码
			refreshCode() {
				this.identifyCode = ''
				this.makeCode(this.identifyCodes, 4)
			},
			// 生成四位随机验证码
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					]
				}
			},
			//登录
			submitForm() {

				const self = this;

				// //判断复选框是否被勾选 勾选则调用配置
				// if (self.checked == true) {
				// 	//传入邮箱号，密码
				// 	self.setsessionStorage(self.param.username, self.param.password)
				// } else {
				// 	//清空clearsessionStorage
				// 	self.clearsessionStorage()
				// }

				//保存的账号
				var name = self.param.username;
				//保存的密码
				var pass = self.param.password;
				//判断复选框是否被勾选 勾选则调用配置cookie方法
				if (this.checked) {
					//传入账号名，密码，和保存天数3个参数
					this.setCookie(name, pass, 365);
				}

				// 点击登陆向后台提交登陆信息
				this.$refs.login.validate(valid => {
					if (valid) {

						this.authLoading = true
						this.isDisabled = true

						//http://localhost:62892/WCF/WEB/svcUAA.svc/Login
						var loginUrl = 'WCF/WEB/svcUAA.svc/Login';
						//网络请求接口
						this.$axios.post(
								//请求的url
								loginUrl,
								//请求参数
								{
									sPHON: self.param.username,
									sPassword: this.$md5(self.param.password)
								}
							)
							.then((response) => {

								//请求成功返回的数据
								let resCount = response.data.KKDTCOUNT;
								let rescode = response.data.KKDT[0].code;

								if (resCount > 0) {
									if (rescode == '200') {
										//登录成功
										this.$message.success(this.login.login_13); //登录成功
										//登录成功，储存登录信息
										sessionStorage.setItem('ms_role', response.data.KKDT[0].UAAROLE); //存储登录角色
										sessionStorage.setItem('ms_web_suuid', response.data.KKDT[0].UAAMSID); //登录用户ID
										sessionStorage.setItem('ms_username', response.data.KKDT[0].UAAPHON); //存储登录邮箱
										sessionStorage.setItem('ms_userimg', response.data.KKDT[0].UAAPHOT); //存储登录头像

										this.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
										//跳转到后台主界面
										this.$router.push('/home');
										
									} else if (rescode == '100000') {
										this.$message({
											message: this.login.login_14, //该邮箱未注册
											type: 'error'
										});
									} else if (rescode == '100001') {
										this.$message({
											message: this.login.login_15, //邮箱或密码错误
											type: 'error'
										});
									} else if (rescode == '100002') {
										this.$message({
											message: this.login.login_21, //店员不可以登录后台
											type: 'error'
										});
									}
								}
							})
							.catch((error) => {
								this.$message({
									message: this.login.login_16, //请求失败
									type: 'error'
								});
							});

						this.authLoading = false
						this.isDisabled = false
					}
				});
			},
			// //向sessionStorage里存入从页面获取的邮箱和密码
			// setsessionStorage(c_name, c_pwd) {
			// 	sessionStorage.setItem('ms_username', c_name);
			// 	sessionStorage.setItem('ms_password', c_pwd);
			// },
			// getsessionStorage: function() {
			// 	this.param.username = sessionStorage.getItem('ms_username');
			// 	this.param.password = sessionStorage.getItem('ms_password');
			// },
			// // 清空sessionStorage里的存储
			// clearsessionStorage: function() {
			// 	this.setsessionStorage('', '')
			// }

			//设置cookie
			setCookie(c_name, c_pwd, exdays) {
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			//读取cookie
			getCookie: function() {
				//console.log("--读取cookie--"+document.cookie)
				if (document.cookie.length > 0) {
					var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
					for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split("="); //再次切割
						//判断查找相对应的值
						if (arr2[0] == "userName") {
							this.param.username = arr2[1]; //保存到保存数据的地方
						} else if (arr2[0] == "userPwd") {
							this.param.password = arr2[1];
						}
					}
				}
			},
			//清除cookie
			clearCookie: function() {
				this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
			}
		}
	};
</script>

<style scoped>
	.login-wrap {
		position: relative;
		width: 100%;
		height: 100%;
		background-image: url(../assets/img/login-bg.jpg);
		background-size: 100%;
	}

	.user-language {
		position: relative;
		float: right;
	}

	.el-dropdown-link {
		color: rgb(24, 144, 255);
		cursor: pointer;
	}

	.el-dropdown-menu__item {
		text-align: center;
	}

	.ms-title {
		width: 100%;
		line-height: 50px;
		text-align: center;
		font-size: 32px;
		font-weight: bold;
		color: #1890FF;
		margin-top: 45px;
	}

	.ms-login {
		position: absolute;
		left: 47.4%;
		top: 50%;
		width: 452px;
		height: 478px;
		margin: -190px 0 0 -175px;
		border-radius: 10px;
		background: #F3F3F3;
		overflow: hidden;
		box-shadow: 0 0 10px #999999;
		padding-top: 10px;
		padding-right: 10px;
	}

	.ms-content {
		padding: 30px 50px;
	}

	.ms-username {
		width: 355px;
		margin-top: 10px;
	}

	.ms-password {
		margin-top: 33px;
	}

	.login-txt {
		float: left;
		width: 100%;
		height: 32px;
		margin-top: 15px;
		font-size: 16px;
	}

	.login-txt-forget {
		float: left;
		width: 50%;
		height: 32px;
		line-height: 32px;
	}

	.login-txt-chkbox {
		float: left;
		width: 50%;
		height: 32px;
		line-height: 32px;
	}

	.login-btn {
		float: left;
		width: 100%;
		text-align: center;
	}

	.textforget {
		float: left;
		font-size: 14px;
	}

	.login-btn button {
		width: 100%;
		height: 44px;
		font-size: 18px;
		margin-top: 5px;
		margin-bottom: 10px;
	}

	.login-tips {
		font-size: 12px;
		line-height: 30px;
		color: #fff;
	}

	.identifyinput {
		width: 100%;
	}

	.identifybox {
		display: flex;
		justify-content: space-between;
		margin-top: 7px;
	}

	.textbtn {
		font-size: 12px;
		color: #000000;
	}

	.chkbox {
		float: right;
		height: 44px;
		color: #101010;
	}

	.verifys {
		float: left;
		width: 100%;
		height: 45px;
		margin-top: 15px;
	}

	.verifys-txt {
		float: left;
		width: 50%;
		height: 44px;
	}

	.verifys-image {
		float: left;
		width: 50%;
		height: 44px;
	}

	.verifys-image-code {
		float: left;
		width: 67%;
		padding-left: 8%;
		height: 44px;
		line-height: 44px;
	}

	.verifys-image-button {
		float: left;
		width: 25%;
		height: 35px;
		text-align: center;
	}

	.verifys-image-assets {
		float: left;
		width: 100%;
		height: 20px;
	}

	.verifys-image-textbtn {
		float: left;
		width: 100%;
		height: 25px;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.ms-login>>>.el-input--small .el-input__inner {
		height: 44px;
		line-height: 44px;
		font-size: 16px;
		padding-left: 10px;
	}
</style>
